/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CertificateInfoDto
 */
export interface CertificateInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CertificateInfoDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateInfoDto
     */
    issuer: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateInfoDto
     */
    notBefore: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateInfoDto
     */
    notAfter: string;
    /**
     * 
     * @type {number}
     * @memberof CertificateInfoDto
     */
    readonly daysLeft?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CertificateInfoDto
     */
    readonly isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CertificateInfoDto
     */
    $type?: CertificateInfoDtoTypeEnum;
}


/**
 * @export
 */
export const CertificateInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallCertificateCertificateInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Certificate.CertificateInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CertificateInfoDtoTypeEnum = typeof CertificateInfoDtoTypeEnum[keyof typeof CertificateInfoDtoTypeEnum];


/**
 * Check if a given object implements the CertificateInfoDto interface.
 */
export function instanceOfCertificateInfoDto(value?: unknown): value is CertificateInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CertificateInfoDtoTypeEnum)[0];
}

export function CertificateInfoDtoFromJSON(json: any): CertificateInfoDto {
    return CertificateInfoDtoFromJSONTyped(json, false);
}

export function CertificateInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificateInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'issuer': json['issuer'],
        'notBefore': json['notBefore'],
        'notAfter': json['notAfter'],
        'daysLeft': !exists(json, 'daysLeft') ? undefined : json['daysLeft'],
        'isValid': !exists(json, 'isValid') ? undefined : json['isValid'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CertificateInfoDtoToJSON(value?: CertificateInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'subject': value.subject,
        'issuer': value.issuer,
        'notBefore': value.notBefore,
        'notAfter': value.notAfter,
        '$type': value.$type,
    });
}

